<template>
    <ion-card>
        <ion-card-header>
            <ion-card-title>
                <ion-item class="ion-no-padding">
                    <h4>{{ $t('ncrypt.vault.content_title') }}</h4>
                    <ion-badge slot="end">{{ files.length }} {{ files.length !== 1 ? $t('ncrypt.files') : $t('ncrypt.file') }}</ion-badge>
                </ion-item>
            </ion-card-title>
        </ion-card-header>
        <ion-card-content>
            <ion-item v-if="!files.length" lines="none" class="ion-no-padding">
                <ion-text>
                    <p>{{ $t('ncrypt.vault.no_files_message') }}</p>
                    <p>{{ $t('ncrypt.vault.no_files_instruction') }}</p>
                </ion-text>
            </ion-item>
            <ion-list v-else lines="none" ref="fileList">
                <vault-file
                        v-on:toggled="fileToggled($event, file)"
                        :file="file"
                        v-for="file in files"
                        v-bind:key="file.id"
                        v-on:refresh="$emit('refresh')"
                        v-on:remove="removeFile(file)"
                        :with-checkbox="true"
                        :can-delete="true"
                />
            </ion-list>
            <ion-button @click="shareSelected" v-show="files.length" expand="block" size="default" shape="round" style="margin: 0 auto;">
                {{ $t('ncrypt.vault.share_selected_files') }}
            </ion-button>
        </ion-card-content>
    </ion-card>
</template>

<script>
    import VaultFile from "./VaultFIle";
    import {Notifier} from "../../services/Notifier";
    import {ApiError} from "../../errors/ApiError";

    export default {
        name: "VaultFileList",
        components: {VaultFile},
        props: {
            files: {type: Array},
        },
        data() {
            return {
                selectedFiles: [],
            }
        },
        methods: {
            fileToggled(checked, file) {
                if (checked) {
                    this.selectedFiles.push(file);
                } else {
                    this.selectedFiles = this.selectedFiles.filter(item => item.id !== file.id);
                }
            },
            shareSelected() {
                this.$router.push({name: 'writeMessage', query: {vaultFiles: this.selectedFiles}});
            },
            removeFile(file) {
                if (!confirm(this.$t('ncrypt.notifications.confirm_delete_vault_file').replace('{filename}', file.name))) {
                    return;
                }

                this.$http.post(`/vault/files/${file.id}/delete`)
                    .then(async () => {
                        await Notifier.showToast({
                            message: this.$t('ncrypt.notifications.vault_file_deleted_toast'),
                        });

                        this.$emit('refresh');
                    })
                    .catch(reason => new ApiError(reason));
            },
        },
    }
</script>
